import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Helmet from "../../component/common/Helmet";
import HeaderThree from "../../component/header/HeaderThree";
import FooterTwo from "../../component/footer/FooterTwo";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import { blogService } from '../../services/blogService';

const BlogDetails = () => {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const data = await blogService.getBlog(id);
                setBlog(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchBlog();
    }, [id]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!blog) {
        return <div>Blog post not found</div>;
    }

    return (
        <div className="active-dark">
            <Helmet pageTitle={`${blog.title} - Blog`} />

            <HeaderThree homeLink="/" logo="symbol-dark" color="color-black" />

            {/* Blog Header */}
            <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--1" data-black-overlay="7">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="blog-single-page-title text-center pt--100">
                                <div className="thumbnail" style={{ borderRadius: '10px', maxWidth: '200px', height: '200px', margin: '0 auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src={blog.cover} alt={blog.title} />
                                </div>
                                <h2 className="title" style={{ color: '#00ACEE' }}>{blog.title}</h2>
                                <div className="blog-meta">
                                    <span>{blog.category}</span>
                                    <span>{blog.date}</span>
                                    <span>{blog.author}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Blog Content */}
            <div className="rn-blog-details pt--110 pb--70 bg_color--1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="inner-wrapper">
                                <div className="inner">
                                    {/* Cover Image */}

                                    {/* Blog Blocks */}
                                    {blog.blocks.map((block, index) => (
                                        <div key={index} className="blog-block">
                                            {block.type === 'text' && (
                                                <p className="blog-content" dangerouslySetInnerHTML={{ __html: block.content }} />
                                            )}
                                            {block.type === 'image' && (
                                                <div className="thumbnail">
                                                    <img src={block.src} alt={block.alt} style={{
                                                        borderRadius: '10px',
                                                        maxWidth: '600px',
                                                        height: '600px',
                                                        margin: '0 auto',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center'
                                                    }} />
                                                </div>
                                            )}
                                        </div>
                                    ))}

                                    {/* Footer */}
                                    <div className="blog-footer">
                                        <p>{blog.footer}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <FooterTwo />

            {/* Back to Top */}
            <div className="backto-top">
                <ScrollToTop showUnder={160}>
                    <FiChevronUp />
                </ScrollToTop>
            </div>
        </div>
    );
};

export default BlogDetails; 